import React from 'react';
import type { FC } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  AppBar,
  Box,
  Hidden,
  IconButton,
  Toolbar,
  makeStyles,
  SvgIcon,
  Typography,
} from '@material-ui/core';
import { Menu as MenuIcon } from 'react-feather';
import Logo from 'src/components/Logo';
import { THEMES } from 'src/constants';
import type { Theme } from 'src/theme';
import Account from './Account';
import Notifications from './Notifications';
import Settings from './Settings';
import Truncate from 'src/components/Truncate';

interface TopBarProps {
  className?: string;
  onMobileNavOpen?: () => void;
  clientName?: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    zIndex: theme.zIndex.drawer + 100,
    ...(theme.name === THEMES.EXO_DARK || theme.name === THEMES.EXO_BLUE) ? {
      boxShadow: 'none',
      backgroundColor: theme.palette.primary.main
    } : {},
    ...(theme.name === THEMES.DARK_MODE || theme.name === THEMES.EXO_LIGHT) ? {
      backgroundColor: theme.palette.background.default
    } : {},
    ...theme.name === THEMES.EXO_LIGHT ? {
      color: theme.palette.primary.main
    } : { color: '#ffffff' },
  },
  toolbar: {
    minHeight: 64
  },
  client: {
    flexGrow: 1,
  }
}));

const TopBar: FC<TopBarProps> = ({
  className,
  onMobileNavOpen,
  clientName,
  ...rest
}) => {
  const classes = useStyles();
  return (
    <AppBar
      className={clsx(classes.root, className)}
      {...rest}
    >
      <Toolbar className={classes.toolbar}>
        <Hidden lgUp>
          <IconButton
            color="inherit"
            onClick={onMobileNavOpen}
          >
            <SvgIcon fontSize="small">
              <MenuIcon />
            </SvgIcon>
          </IconButton>
        </Hidden>
        <Hidden mdDown>
          <RouterLink to="/">
            <Logo style={{ width: '100px' }} />
          </RouterLink>
          <Box ml={18}>
            <Typography variant="h5" className={classes.client}>
              <Truncate value={clientName ?? ''} />
            </Typography>
          </Box>
        </Hidden>

        <Box
          ml={2}
          flexGrow={1}
        />
        {/* <Search /> */}

        <Notifications />
        <Settings />
        <Box ml={2}>
          <Account />
        </Box>
      </Toolbar>
    </AppBar >
  );
};

TopBar.propTypes = {
  className: PropTypes.string,
  onMobileNavOpen: PropTypes.func
};

TopBar.defaultProps = {
  onMobileNavOpen: () => { }
};

export default TopBar;
